import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

export const AutoLogoutWrapper = styled('div', { label: 'AutoLogoutWrapper' })`
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-family: var(--font-family-primary);
`;

export const AutoLogoutDescription = styled('p', { label: 'AutoLogoutDescription' })`
    margin: 0;
    font-size: 14px;
    line-height: 1.43;
    color: ${mainColors.grays.gray500};
`;

export const AutoLogoutSection = styled('section', { label: 'AutoLogoutSection' })`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    border: 1px solid ${mainColors.grays.gray200};
    border-radius: 8px;
    background-color: ${mainColors.default.light};
`;

export const AutoLogoutSectionTitle = styled('h3', { label: 'AutoLogoutSectionTitle' })`
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.43;
    color: ${mainColors.main.primary};
`;

export const AutoLogoutFormFields = styled('div', { label: 'AutoLogoutFormFields' })`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const AutoLogoutFormRow = styled('div', { label: 'AutoLogoutFormRow' })`
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (min-width: 768px) {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
    }
`;

export const AutoLogoutFormLabel = styled('label', { label: 'AutoLogoutFormLabel' })`
    font-size: 14px;
    font-weight: 500;
    line-height: 1.43;
    color: ${mainColors.main.primary};
    flex: 1;
`;

export const AutoLogoutFormValue = styled('div', { label: 'AutoLogoutFormValue' })`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    max-width: 280px;
`;

export const AutoLogoutUnitSuffix = styled('span', { label: 'AutoLogoutUnitSuffix' })`
    font-size: 14px;
    font-weight: 500;
    line-height: 1.43;
    color: ${mainColors.grays.gray500};
    flex-shrink: 0;
`;

export const AutoLogoutActions = styled('div', { label: 'AutoLogoutActions' })`
    display: flex;
    justify-content: flex-start;
    margin-top: 24px;
`;
